function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#decision_svg__clip0_75_5070)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 12.998h6.923H1zm6 0V10.69H1.923v2.308",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 12.998h6.923m-.923 0V10.69H1.923v2.308",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.727 1.655l-3.31 3.31a.923.923 0 000 1.305L5.88 7.732c.36.36.945.36 1.305 0l3.31-3.31a.923.923 0 000-1.305L9.031 1.655a.923.923 0 00-1.305 0z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.846 6.074L13 10.228",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "decision_svg__clip0_75_5070"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));

var SvgDecision = function SvgDecision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgDecision;